import React from 'react'
import { convertOrderStateTypeToString, convertPaymentStateTypeToString } from '../../utils/event-utils'
import { Stack, Typography, useTheme } from '@mui/material'
import { OrderStateChangeDto, PaymentStateChangeDto } from '../../services/api/sharedTypes/Event'

interface EventSateHistoryProps {
    orderStateChanges: OrderStateChangeDto[]
    paymentStateChanges: PaymentStateChangeDto[]
}

const EventStateHistory: React.FC<EventSateHistoryProps> = ({
    orderStateChanges,
    paymentStateChanges,
}: EventSateHistoryProps) => {
    const theme = useTheme()

    return (
        <div
            style={{
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(3),
            }}
        >
            <Stack spacing={3}>
                <Typography variant='h6' color='primary'>Stav zakázky</Typography>
                <Stack direction='row' justifyContent='space-between' spacing={5}>
                    <Typography variant='caption'>Stav</Typography>
                    <Typography variant='caption'>Datum</Typography>
                </Stack>
                {orderStateChanges.map((stateChange, index: number) => (
                    <Stack direction='row' justifyContent='space-between' spacing={5} key={index}>
                        <Typography variant='body1'>{convertOrderStateTypeToString(stateChange.orderState)}</Typography>
                        <Typography variant='body1'>{new Date(stateChange.timestamp).toLocaleString('cs')}</Typography>
                    </Stack>
                ))}
                <Typography variant='h6' color='primary'>Platby</Typography>
                <Stack direction='row' justifyContent='space-between' spacing={5}>
                    <Typography variant='caption'>Stav</Typography>
                    <Typography variant='caption'>Datum</Typography>
                </Stack>
                {paymentStateChanges.map((stateChange, index: number) => (
                    <Stack direction='row' justifyContent='space-between' spacing={5} key={index}>
                        <Typography variant='body1'>{convertPaymentStateTypeToString(stateChange.paymentState)}</Typography>
                        <Typography variant='body1'>{new Date(stateChange.timestamp).toLocaleString('cs')}</Typography>
                    </Stack>
                ))}
            </Stack>
        </div>
    )
}

export default EventStateHistory
